import React from 'react';
import TagMenu from '../TagMenu/TagMenu';

const ModuleTagMenu = ({
  tagMenuVersion,
  primaryColor,
  secondaryColor,
  companyWelcome,
}) => {
  return (
    <TagMenu
      tagMenuVersion={tagMenuVersion}
      primaryColor={primaryColor}
      secondaryColor={secondaryColor}
      companyWelcome={companyWelcome}
    />
  );
};

export default ModuleTagMenu;
